<script lang="ts" setup>
import { useHead } from '@unhead/vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { getCanonicalUrl } from '@/utilities';
import FeaturedProjects from '@/views/home/FeaturedProjects.vue';
import EditorialHome from '@/views/home/EditorialHome.vue';
import SearchPathways from '@/views/home/SearchPathways.vue';
import ExploreHome from '@/views/home/ExploreHome.vue';
import NewProjects from '@/views/search/NewProjects.vue';

const { t } = useI18n();
const route = useRoute();

const canonicalUrl = getCanonicalUrl(route.path);

useHead({
  title: t('views.home.title'),
  meta: [
    {
      name: 'description',
      content: t('views.home.meta.description'),
    },
    { property: 'og:title', content: t('views.home.title') },
    { property: 'og:description', content: t('views.home.meta.description') },
    { property: 'og:url', content: canonicalUrl },
    { name: 'twitter:title', content: t('views.home.title') },
    { name: 'twitter:description', content: t('views.home.meta.description') },
    { name: 'twitter:card', content: 'summary' },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: t('global.site-name'),
        url: canonicalUrl,
      }),
    },
  ],
});
</script>

<template>
  <h1 class="sr-only">{{ t('views.home.title') }}</h1>
  <SearchPathways />
  <FeaturedProjects />
  <NewProjects placement="home" />
  <ExploreHome />
  <EditorialHome />
</template>

<style lang="css" scoped></style>
